import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { OtLinkExternal } from '@1trading/design-system';

import { capIsNativePlatform } from '@exchange/libs/utils/capacitor/src';

import { nativeOpenLink } from './link-external-helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'XLinkExternal',
  props: {
  href: { type: String, required: true },
  useSystemBrowser: { type: Boolean, default: false } /** Native only: Use to determine whether system or in-app browser is used. Ignored on web. */,
},
  emits: ["click"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const isNative = capIsNativePlatform();

const onClick = (e: Event) => {
  emit('click', e);
  nativeOpenLink(props.href, props.useSystemBrowser);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(OtLinkExternal), _mergeProps({
    class: "x-link-external",
    href: __props.href,
    "is-native": _unref(isNative),
    "use-system-browser": __props.useSystemBrowser
  }, _ctx.$attrs, { onClick: onClick }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["href", "is-native", "use-system-browser"]))
}
}

})